import React, { Component } from "react";
import classnames from "classnames";
import _ from "i18n";

import { SLIDES_TABS } from "Config";

import { ICONS, SvgIcon } from "../Common/Icons";
import SearchBox from "../Common/filters/SearchBox";
import NotFoundV2 from "../NotFound/NotFoundV2";
import Slide from "../Dashboard/Slide";

import styles from "./DashboardCompositionPage.local.scss";
import { connect } from "react-redux";
import { getLabelsByLng } from "../../utils";

class SlidesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedIndex: ["USED", "STANDARD", "CREATED", "ALL"],
      selectedStatus: "all",
      disposition: "GRID",
      slidesSearch: ""
    };
  }

  handleChangeSlidesSearch = search => {
    if (search.length > 2 || search.length === 0) {
      this.setState({ slidesSearch: search.toLowerCase() });
    }
  };
  handleSlidesSearch = (slide, search) => {
    return (
      slide.labels["fr"].toLowerCase().indexOf(search) > -1 ||
      slide.labels["en"].toLowerCase().indexOf(search) > -1 ||
      slide.labels["nl"].toLowerCase().indexOf(search) > -1
    );
  };
  handleSelectSlidesType = index => {
    this.setState({
      selectedStatus: index
    });
  };

  isAlreadySelected = id => {
    const {
      composition: { slidesOrder }
    } = this.props;

    for (let i = 0; i < slidesOrder.length; i++) {
      if (id === slidesOrder[i]) {
        return true;
      }
    }
    return false;
  };

  setDisposition = dispo => {
    this.setState({ disposition: dispo });
  };

  renderSlidesByType = slides => {
    const { disposition } = this.state;
    return (
      <div>
        {disposition === "GRID"
          ? this.renderSlidesGridDisposition(slides)
          : this.renderSlidesListDisposition(slides)}
      </div>
    );
  };

  renderSlidesGridDisposition = slides => {
    const { lng } = this.props;
    return (
      <div className={styles.slides_list}>
        {slides.map((slide, i) => {
          return (
            <div
              className={classnames(
                styles.slides_min,
                this.isAlreadySelected(slide.id) && styles.already_selected
              )}
              key={"slideList_" + i}
            >
              <span className={styles.slide_label}>
                {getLabelsByLng(slide.labels, lng)}
              </span>
              <div className={styles.slide_frame}>
                <Slide
                  key={slide.id}
                  slide={slide}
                  isResponsive={false}
                  handleSlideListOnClick={
                    !this.isAlreadySelected(slide.id)
                      ? () => this.props.handleAddSlideToDashboard(slide.id)
                      : null
                  }
                  comments={this.props.comments}
                />
                <img
                  src={"/img/icons/x.svg"}
                  alt={""}
                  className={styles.arrow_left}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  renderSlidesListDisposition = slides => {
    const { lng } = this.props;
    return (
      <div className={styles.labels_list}>
        {slides.map((slide, i) => {
          return (
            <div
              className={classnames(
                styles.slide_frame,
                this.isAlreadySelected(slide.id) && styles.already_selected
              )}
            >
              <div
                className={styles.slide_labels_list}
                key={"slideList_" + i}
                onClick={
                  !this.isAlreadySelected(slide.id)
                    ? () => this.props.handleAddSlideToDashboard(slide.id)
                    : null
                }
              >
                <span className={styles.slide_label}>
                  {getLabelsByLng(slide.labels, lng)}
                </span>
              </div>
              <img
                src={"/img/icons/x.svg"}
                alt={""}
                className={styles.arrow_left}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderActionsBox = () => {
    return (
      <div className={styles.actions_box}>
        <SearchBox
          placeholder={_("search")}
          onChange={this.handleChangeSlidesSearch.bind(this)}
        />
        <button
          type="button"
          className={classnames(
            styles.disposition_button,
            this.state.disposition === "GRID" && styles.active
          )}
          onClick={() => this.setDisposition("GRID")}
        >
          <SvgIcon icon={ICONS.GRID} />
        </button>
        <button
          type="button"
          className={classnames(
            styles.disposition_button,
            styles.disposition_button_list,
            this.state.disposition === "LIST" && styles.active_list
          )}
          onClick={() => this.setDisposition("LIST")}
        >
          <SvgIcon icon={ICONS.MENU} />
        </button>
      </div>
    );
  };

  render() {
    const { slides, backOffice } = this.props;
    let { selectedStatus } = this.state;
    const filteredSlides = slides[!backOffice ? selectedStatus : "standard"]
      ? slides[!backOffice ? selectedStatus : "standard"].filter(slide =>
          this.handleSlidesSearch(slide, this.state.slidesSearch)
        )
      : [...slides.standard, ...(slides.created || slides.used || [])].filter(
          slide => this.handleSlidesSearch(slide, this.state.slidesSearch)
        );
    return (
      <div>
        {!backOffice ? (
          <div className={styles.tabs}>
            {SLIDES_TABS.map((type, i) => {
              return (
                <div
                  key={i}
                  className={
                    styles.tab_badge +
                    " " +
                    (selectedStatus === type.value
                      ? styles.tab_badge_active
                      : "")
                  }
                  onClick={() => this.handleSelectSlidesType(type.value)}
                >
                  {_(type.label)}{" "}
                  {slides[type.value]
                    ? `(${slides[type.value].length})`
                    : `(${
                        [
                          ...slides.standard,
                          ...slides.used,
                          ...(slides.created || [])
                        ].length
                      })`}
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}
        {this.renderActionsBox()}
        {filteredSlides.length === 0 && <NotFoundV2 />}
        {filteredSlides.length > 0 && this.renderSlidesByType(filteredSlides)}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng
});

export default connect(mapStateToProps)(SlidesList);



// WEBPACK FOOTER //
// ./src/components/DashboardComposition/SlidesList.js